import { useState, useRef } from 'react';
import getNaturalTimeString from '../../common/basic';

export default props=>{
  if (!props.me) return <></>;

  const rSentence = useRef(null);
  const [vSentence, setSentence] = useState(props.me.content);

  return (<div className="">
    <style jsx>{`

.psa{
    vertical-align:top;
    // padding: 5px 0 0 0;
    padding: 0;
}

.left {
  float: left;
}

.center{
  overflow:hidden;
}

.cu1{
  font-size: 14px;
  color: #343a40;
}

.cu2{
  font-size: 10px;
  color: #868e96;
}


.bottom{
    /* padding: 10px 5px 5px 5px; */

}

.textarea1{
    padding: 10px 5px;
    border: 0;
    border-top: solid 1px #d8d8d8;
    border-bottom: solid 1px #d8d8d8;
    width: 100%;
    height: 100px;
    resize: none;

}

.l2{
  text-align: right;
}


.whitebutton55{
    width: 55px;
    height: 32px;
    line-height: 32px;

    margin: 0 2px;
    border: solid 1px #adb5bd;

    font-size: 14px;
    text-align: center;
    color: #343a40;

    box-sizing: border-box;
}


.blackbutton55 {
    width: 55px;
    height: 32px;
    line-height: 32px;
    background-color: #343a40;
  
    margin: 0 2px;
    border: solid 1px #adb5bd;

    font-size: 14px;
    text-align: center;
    color: white;
  
    box-sizing: border-box;
}



@media all and (max-width:606px) {
}


`}</style>

    <div className="splitter">
      <div className="dib left psa">
        <img src={
          props.me.user && props.me.user.profile_picture[0]
            ? props.me.user.profile_picture[0].optimized_url
            : "/assets/images/ico-empty.svg"}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
      <div className="center">
        <div className="dib cu1">
          {props.me && props.me.user && props.me.user.username ? props.me.user.username : 'none'}
      </div>&nbsp;&nbsp;&nbsp;
      <div className="dib cu2">
          {getNaturalTimeString(props.me.created_at)}
      </div>
        <div className="cl">
          <div className="bottom">
            <textarea className="textarea1" ref={rSentence} defaultValue={props.me.content} 
            // placeholder=" 댓글 작성"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div className="l2">
      <a onClick={()=>{
        props.hide();
      }}><div className="dib whitebutton55">취소</div></a>
      <a onClick={() => {
        props.hide();
        props.updateReply(rSentence.current.value);
      }}><div className="dib blackbutton55">등록</div></a>

    </div>
    <div className="">&nbsp;</div>
  </div>);

}
